<template>
  <BaiduMap
    class="baidu-map"
    :center="options.center"
    :zoom="options.zoom"
    :scroll-wheel-zoom="true"
    :ak="apiKey"
  >
    <BaiduMapType
      v-if="options.mapTypeSelector"
      :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
      anchor="BMAP_ANCHOR_TOP_LEFT"
    />
    <BaiduNavigation
      anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
      :showZoomInfo="false"
      type="BMAP_NAVIGATION_CONTROL_ZOOM"
    />
    <BaiduScale anchor="BMAP_ANCHOR_BOTTOM_RIGHT" />

    <BaiduMarker
      v-for="(marker, i) in markers"
      :key="i"
      :position="marker.position"
      :icon="{ url: marker.options.icon, size: { width: 61, height: 61 } }"
      @click="toggleMarker({ i, marker })"
    />

    <BaiduOverlay
      v-if="overlayVisible"
      class="baidu-map__overlay"
      pane="markerPane"
      @initialize="initialize"
      @draw="draw"
    >
      <slot></slot>
    </BaiduOverlay>
  </BaiduMap>
</template>

<script>
import BaiduMap from "vue-baidu-map-v3/components/map/Map.vue";
import BaiduNavigation from "vue-baidu-map-v3/components/controls/Navigation.vue";
import BaiduScale from "vue-baidu-map-v3/components/controls/Scale.vue";
import BaiduMarker from "vue-baidu-map-v3/components/overlays/Marker.vue";

export default {
  name: "BaiduProvider",
  components: {
    BaiduMap,
    BaiduNavigation,
    BaiduScale,
    BaiduMarker,
    BaiduMapType: () =>
      import("vue-baidu-map-v3/components/controls/MapType.vue"),
    BaiduOverlay: () =>
      import("vue-baidu-map-v3/components/overlays/Overlay.vue"),
  },
  data: () => ({
    overlayVisible: false,
    currentPoint: {},
    mapObjects: {},
  }),
  props: {
    apiKey: {
      type: String,
      default: "",
    },
    markers: {
      type: Array,
      default: () => [
        {
          position: { lng: 52.37008, lat: 39.915 },
        },
      ],
    },
    options: {
      type: Object,
      default: () => ({
        zoom: 12,
        center: { lng: 116.404, lat: 39.915 },
        mapTypeSelector: false,
      }),
    },
  },
  methods: {
    toggleMarker({ i, marker }) {
      if (this.overlayVisible && this.overlayVisible == i) {
        this.overlayVisible = false;
      } else {
        this.$parent.$emit("openMarker", marker);
        this.currentPoint = marker;
        this.overlayVisible = i;
        this.draw(this.mapObjects);
      }
    },
    initialize(mapObjects) {
      this.mapObjects = mapObjects;
    },
    draw({ el, BMap, map }) {
      if (map && BMap && el) {
        const pixel = map.pointToOverlayPixel(
          new BMap.Point(
            this.currentPoint.position.lng,
            this.currentPoint.position.lat
          )
        );
        el.style.left = pixel.x + "px";
        el.style.top = pixel.y + "px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.baidu-map {
  height: 380px;
  position: relative;

  &__overlay {
    position: absolute;
  }
}
</style>